import {useTranslation} from "react-i18next";
import React from "react";

const UnlockAIPotentialBlock = ({ title, items, forwardRef }: { title?: string; items?: any[], forwardRef: any }) => {
    const { t } = useTranslation();
    return (
        <div className="unlock-ai-block" ref={forwardRef}>
            <div className="unlock-ai-title">{title || t('subscription.unlockAIPotential')}</div>
            <ul className="unlock-ai-list">
                {(items || []).map((f, i) => {
                    // Helper to get the best icon url
                    let iconUrl = '';
                    if (f.icon) {
                        if (typeof f.icon === 'string') iconUrl = f.icon;
                        else if (f.icon.formats?.thumbnail?.url) iconUrl = f.icon.formats.thumbnail.url;
                        else if (f.icon.formats?.small?.url) iconUrl = f.icon.formats.small.url;
                        else if (f.icon.url) iconUrl = f.icon.url;
                    }
                    return (
                        <li className="unlock-ai-item" key={i}>
                            {iconUrl && <img src={iconUrl} alt={f.title} className="unlock-ai-icon" />}
                            <div>
                                <div className="unlock-ai-item-title">{f.title}</div>
                                <div className="unlock-ai-item-desc">{f.description}</div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default UnlockAIPotentialBlock

